export const emailResponse = 'Invalid email address'
export const inboundCheckResponse = 'inbound_policy_already_exists'
export const incorrectTravelTypeResponse = 'visitors_incorrect_travel_type'